import axios from 'axios'

class APIMailGruppo {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = "https://companysupport.eu/";

    }

    return result + "public/api/alertduedate/" + nome_metodo;

  }

  async setMailGruppo(mail_gruppo, id, user) {


    let formData = new FormData();

    formData.append("id", id);
    formData.append("v_user", user);

    for (var key in mail_gruppo) {
      formData.append(key, mail_gruppo[key]);
    }

    return axios.post(this.getUrlDomain("setMailGruppo"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async getMailGruppo(id, user) {


    let formData = new FormData();

    formData.append("id", id);
    formData.append("v_user", user);


    return axios.post(this.getUrlDomain("getMailGruppo"), formData, { 'Content-Type': 'multipart/form-data' });

  }



  async deleteMailGruppo(id, user) {


    let formData = new FormData();

    formData.append("id", id);
    formData.append("v_user", user);


    return axios.post(this.getUrlDomain("deleteMailGruppo"), formData, { 'Content-Type': 'multipart/form-data' });

  }








}

export default new APIMailGruppo({
  url: "http://emtool.local/public/api/alertduedate/"
})
